// extracted by mini-css-extract-plugin
export var callCard = "_my-0";
export var callMessageButton = "_my-1";
export var helpIcon = "_my-3";
export var helpIconContainer = "_my-4";
export var verticalDivider = "_my-2";